<template>
  <div class="nps_input">
    <Formfield :required="required" :helpText="helpText" :label="label">
      <div class="nps_input__rating-and-scale">
        <NpsInput
          class="nps_input__rating_input"
          v-model="inputValue"
          :required="required"
        />
        <div class="nps_input__scale">
          <span>{{ inputWorstLabel }}</span>
          <span>{{ inputBestLabel }}</span>
        </div>
      </div>
    </Formfield>
  </div>
</template>

<script>
import BaseComponent from "../BaseComponent";
import Formfield from "./Formfield.vue";
import NpsInput from "../atoms/Inputs/NpsInput.vue";
import InputBase from "../atoms/Inputs/mixins/InputBase";
import FormMixin from "../mixins/FormMixin";

/**
 * @group Questions
 * NPS input with a Formfield wrapped around it.
 */
export default {
  name: "NpsQuestion",
  mixins: [BaseComponent, InputBase, FormMixin],
  components: {
    NpsInput,
    Formfield,
  },
  props: {
    // The Question
    label: {
      type: String,
      required: true,
    },
    // The Hint
    helpText: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    inputWorstLabel: {
      type: String,
      default: "not likely",
    },
    inputBestLabel: {
      type: String,
      default: "extremely likely",
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../style_variables/style_variables.scss";

.nps_input {
  width: 100%;
  max-width: $input_max_width;

  .nps_input__label {
    grid-area: label;
  }
  .nps_input__rating-and-scale {
    width: 100%;
  }
  .nps_input__scale {
    @extend %body2_style;
    display: flex;
    width: 100%;
    justify-content: space-between;
    color: $grey_french;
    margin-top: 4px;
  }
}
</style>
